import {
  getValueFromObjectByPrefix,
  menuFromMap,
  arrayWithoutDublicates
} from '../utils';

import {
  modifySupportLink,
  modifyEcommerceLink,
  modifySocialNetwork,
  modifyEnOnlyLinks,
  modifyDomainLink,
} from './common';

import {
  socialNetworks,
  linkModifiers
} from '../data/constants.json';

import * as cssMobile from './footer/mobile.scss';
import * as cssDesktop from './footer/desktop.scss';
import htmlMobile from './footer/mobile';
import htmlDesktop from './footer/desktop';

const {localizedSocialNetworks} = linkModifiers;

const icons = arrayWithoutDublicates([].concat(socialNetworks.mobile, socialNetworks.desktop))
  .reduce((object, name) => Object.assign(object, {[name]: require(`./svg/${name}`).default}), {});

function getSocialLinks(t, tLinks, isMobile, language) {
  const css = isMobile ? cssMobile : cssDesktop;
  return socialNetworks[isMobile ? 'mobile' : 'desktop'].map(network => ({
    text: icons[network],
    href: localizedSocialNetworks[network] && localizedSocialNetworks[network][language] ?
      localizedSocialNetworks[network][language] : tLinks(network),
    classes: `${css.icon} ${css[`icon-inline-${network}`]}`,
    contentAttrs: {target: '_blank', 'aria-label': network}
  }));
}

export default ({map, translations, isMobile, config, user}) => {
  const t = getValueFromObjectByPrefix(translations, 'footer_');
  const tAll = getValueFromObjectByPrefix(translations);
  const tLinks = getValueFromObjectByPrefix(translations, 'link_');
  const socialLinks = getSocialLinks(t, tLinks, isMobile, config.language);

  const mainLinks = menuFromMap(
    map,
    `footer.nav`, // hardcode to get the same links for desktop and mobile
    // `footer.${isMobile ? 'mobileNav' : 'nav'}`,
    translations,
    config.language,
    [modifySupportLink, modifyEcommerceLink, modifySocialNetwork, modifyEnOnlyLinks, modifyDomainLink(user)],
    tAll,
  );

  return {true: htmlMobile, false: htmlDesktop}[isMobile]({mainLinks, socialLinks, t, config, tAll});
};
